
import LanguageService from "../../../services/Language.service";
import {PRODUCT_TYPE} from "../../../constants/ProductDetails.constants";

export const getTickerData = (tickerData, note, tickerCompaniesList) => {
    if(tickerData.code === note.code) {
        if (note.productType === PRODUCT_TYPE.indexLinked || note.productType === PRODUCT_TYPE.fundLinked || note.productType === PRODUCT_TYPE.commodityLinked) {
            tickerCompaniesList.push(LanguageService.chooseLang(tickerData.underlyingInformation.tickerCompany, tickerData.underlyingInformation.tickerCompanyFr));
        } else if (note.productType === PRODUCT_TYPE.equityLinked || note.productType === PRODUCT_TYPE.multiAsset) {
            tickerCompaniesList.push(LanguageService.chooseLang(tickerData.underlyingInformation.shortTicker, tickerData.underlyingInformation.shortTicker));
        }
    }
};
